import { gql, useMutation } from '@apollo/client'
import {
  MutationBookingLocationsChangeArgs,
  MutationBookingLocationsChangePayload,
} from 'src/generated'

const MUTATION_BOOKING_LOCATIONS_CHANGE = gql`
  mutation BookingChangeLocations(
    $input: MutationBookingLocationsChangeInput!
  ) {
    bookingLocationsChange(input: $input) {
      bookingRental {
        id
        startLocation {
          id
        }
        endLocation {
          id
        }
      }
    }
  }
`

const useBookingLocationsChangeMutation = () => {
  return useMutation<
    { bookingChangeLocations: MutationBookingLocationsChangePayload },
    MutationBookingLocationsChangeArgs
  >(MUTATION_BOOKING_LOCATIONS_CHANGE)
}

export default useBookingLocationsChangeMutation
